import React from "react";

import "./courseheader.styles.css";
const CourseHeader = () => {
  return (
    <section className="course__header d-flex align-items-center">
      <div className="">
        <div className="teacher--details d-flex">
          <img src="https://images.unsplash.com/photo-1520512202623-51c5c53957df?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fGxhdWdoaW5nJTIwd29tYW58ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt=""/>

          <div className="teacher--details--bio">
            <h2>Maya James</h2>
            <p>Product designer at klen</p>
          </div>
        </div>
        <h1>How to get started with klen</h1>
        <span className="course--tag">Course - 0 modules</span>
      </div>

      <span className="yellow extras"></span>
      <span className="peach extras"></span>
      <span className="torquise extras"></span>
    </section>
  );
};

export default CourseHeader;
